<template>
  <nav class="navbar is-fixed-top navbar-brand">
    <router-link class="navbar-item is-tab" to="/" exact>Betygsätt</router-link>
    <router-link class="navbar-item is-tab" to="/list-beers">Provat</router-link>
    <!--router-link class="navbar-item is-tab" to="/my-beers">Mina öl</router-link-->
    <router-link class="navbar-item is-tab" to="/facts">Fakta</router-link>
    <router-link class="navbar-item is-tab is-hidden-mobile" to="/add-new">Ny provning</router-link>
  </nav>
</template>

<script>
export default {
  name: 'navbar'
}
</script>

<style lang="scss">
@import '../assets/styles/config.scss';

  .navbar {
    background-color: $color_dark !important;

    .navbar-item {
      background-color: $color_dark;
      color: #f5f5f5;

      &.is-tab:hover {
        color: darken(#f5f5f5, 20%);
        border-bottom-color: darken(#f5f5f5, 20%);
      }

      &.is-tab.is-active {
        color: $color_accent;
        border-bottom-color: $color_accent;
      }

    }
  }
</style>



// WEBPACK FOOTER //
// Navbar.vue?7d18a21a